<template>
    <h2>Hello World from OmniSearch! (University search)</h2>
</template>